// extracted by mini-css-extract-plugin
export default {"arrow":"style_arrow__gSr-y","formGroup":"style_formGroup__bIBEq","actions":"style_actions__fNAzW"};